export class OneDriveConsentError extends Error {
  constructor(public readonly cause: unknown) {
    super('Could not acquire delegated Files.ReadWrite consent');
    this.name = 'OneDriveConsentError';
  }
}
